import { IChungChiChungNhanActionTypes } from "../../action-types/chung-chi-chung-nhan/chungChiChungNhanActions";
import { IChungChiChungNhanReducer } from "../../reducer-model/chung-chi-chung-nhan/IChungChiChungNhanReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState : IChungChiChungNhanReducer = {
    status: eReducerStatusBase.is_not_initialization,
    chungChiChungNhans: [],
};

export const chungChiChungNhanReducer = (state: IChungChiChungNhanReducer = iniState, action: IChungChiChungNhanActionTypes): IChungChiChungNhanReducer => {
    switch (action.type) {
        case "CHUNG_CHI_CHUNG_NHAN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "CHUNG_CHI_CHUNG_NHAN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chungChiChungNhans: action.payload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_CHUNG_NHAN_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "CHUNG_CHI_CHUNG_NHAN_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                chungChiChungNhanEdit: action.payload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "CHUNG_CHI_CHUNG_NHAN_SHOW_CHI_TIET_MODAL":
            return {
                ...state,
                isShowChiTietModal: true,
                chungChiChungNhanEdit: action.payload,
            };
        case "CHUNG_CHI_CHUNG_NHAN_CLOSE_CHI_TIET_MODAL":
            return {
                ...state,
                isShowChiTietModal: false,
            };
        default:
            return state;
    }   
}